import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@monekineko/ui-kit/styles.css";
import "@monekineko/game-ui/styles.css";
import { App } from "./App.js";
import { SessionProvider } from "./state/session.js";
import { initTelegram } from "./telegram.js";

initTelegram();
document.documentElement.dataset.theme = "game";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </StrictMode>,
);
